import { render, staticRenderFns } from "./contractdocument-files-view.vue?vue&type=template&id=a6fa234c&scoped=true&"
import script from "./contractdocument-files-view.vue?vue&type=script&lang=js&"
export * from "./contractdocument-files-view.vue?vue&type=script&lang=js&"
import style0 from "./contractdocument-files-view.vue?vue&type=style&index=0&id=a6fa234c&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fa234c",
  null
  
)

export default component.exports